import React, { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb"; // Import Breadcrumb component
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import axiosInstance from "../../axiosInstance";
import { useHistory } from "react-router-dom";
import ConfirmationDialog from "../ConfirmationDialog/ConfirmationDialog";
import toast, { Toaster } from "react-hot-toast";
import Spinner from "react-bootstrap/Spinner";
import "./Track.css";

const RaceTrackMap = () => {
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userRole, setUserRole] = useState(null); // ✅ Added userRole state
  const history = useHistory();
  const [showDialog, setShowDialog] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({
    title: "",
    bodyText: "",
    confirmText: "",
    cancelText: "",
    onConfirm: () => {},
  });

  useEffect(() => {
    fetchTracks();
    fetchUserRole();
  }, []);


 // Fetch user role from /users/currentUser
  const fetchUserRole = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.get("/users/currentUser", {
                  headers: {
                        "Authorization": token,
                  },
            });

       if (response.data.success && response.data.data.user) {
                    setUserRole(response.data.data.user.role); // Set the user role
                }
    } catch (error) {
                console.error("Error fetching user role:", error);
            }
  };

  const fetchTracks = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axiosInstance.get("/track", {
        headers: {
          Authorization: token,
        },
      });
      if (response.status === 200 && response.data.success) {
        if (response.data.data.length === 0) {
          setError("No Tracks Found.");
          setTracks([]);
        } else {
          setTracks(response.data.data);
          setError(null);
        }
      } else {
        setError(response.data.error?.message || "Tracks Not Found.");
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setError("Tracks Not Found.");
      } else {
        setError("Failed to fetch tracks. Please try again.");
      }
      console.error("Fetch Tracks Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddTrack = () => {
    history.push("/add-track");
  };

  const handleNext = () => {
    history.push("/configurations");
  };

  const handleDeleteTrack = (id, e) => {
    e.stopPropagation();
    setDialogConfig({
      title: "Delete Track?",
      bodyText: "Are you sure you want to delete this track?",
      confirmText: "Delete",
      cancelText: "Cancel",
      onConfirm: () => confirmDeleteTrack(id),
    });
    setShowDialog(true);
  };

  const confirmDeleteTrack = async (id) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axiosInstance.delete(`/track/${id}`, {
        headers: {
          Authorization: token,
        },
      });

      if (response.status === 200) {
        toast.success("Track deleted successfully");
        setTracks((prevTracks) => prevTracks.filter((track) => track.trackId !== id));
        handleCloseDialog();
      } else {
        toast.error("Failed to delete track");
      }
    } catch (err) {
      if (err.response?.status === 500 && err.response.data.error?.code === 500) {
        toast.error(
          "Track cannot be deleted because it is referenced by configurations. Please remove related configurations first."
        );
      } else {
        console.error("Error deleting track:", err);
        toast.error("Failed to delete track");
      }
    }
  };

  const handleCloseDialog = () => setShowDialog(false);

  const handleEditTrack = async (id, e) => {
    e.stopPropagation();
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.get(`/track/${id}`, {
        headers: {
          Authorization: token,
        },
      });

      if (response.status === 200 && response.data.success) {
        history.push(`/edit-track/${id}`); // Redirect to the edit page
      } else {
        toast.error("Failed to fetch track details");
      }
    } catch (err) {
      console.error("Error fetching track details:", err);
      toast.error("Error opening edit track page");
    }
  };

  const handleUpdateTrack = (id) => {
    history.push(`/track/${id}`);
  };

  const renderTracks = () => {
    if (tracks.length > 0) {
      return (
        <>
          {tracks.map((track, index) => (
            <Col
              key={index}
              xs={12}
              md={4}
              className="mb-3"
              onClick={() => handleUpdateTrack(track.trackId)}
            >
              <div className="track-card">
                <div
                  style={{
                    backgroundColor: "#ccc",
                    height: "200px",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    style={{
                      height: "100%",
                      marginBottom: "10px",
                      width: "100%",
                      objectFit: "unset",
                    }}
                    src={track.mapImage || "/img/Map/Default-Map.png"}
                    alt={track.trackName}
                  />
                </div>
                <div className="track-info">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5>{track.trackName}</h5>
                     {userRole === "Admin" && (
                    <div>
                      <button
                        className="btn btn-secondary mr-2"
                        onClick={(e) => handleEditTrack(track.trackId, e)}
                      >
                        <i className="fa-solid fa-edit"></i>
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={(e) => handleDeleteTrack(track.trackId, e)}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </button>
                      
                    </div>
                    )}  
                  </div>
                   {userRole === "Admin" && (
                  <div className="track-meta">
                    <span
                    className="clickable-meta"
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push(`/configurations?trackId=${track.trackId}`);
                    }}
                  >
                    {track.configurations?.length ?? 0} Configuration</span>{" "}|{" "}

                    <span
                    className="clickable-meta"
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push(`/races?trackId=${track.trackId}`);
                    }}
                  >
                    {track.races?.length ?? 0} Races
                  </span>{" "}
                  |{" "}
                  <span
                    className="clickable-meta"
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push(`/geo-fences?trackId=${track.trackId}`);
                    }}
                  >
                    {track.geoFences?.length ?? 0} Geo Maps
                  </span>

                  </div>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </>
      );
    } else if (error) {
      return (
        <div
          className="text-center w-100"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "20px",
          }}
        >
          {error}
        </div>
      );
    } else {
      return (
        <div
          className="text-center w-100"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "20px",
          }}
        >
          No Tracks found
        </div>
      );
    }
  };

  return (
    <>
      <ContentWrapper>
        <Container fluid className="pb-0">
          {/* Breadcrumbs Section */}
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Tracks</Breadcrumb.Item>
          </Breadcrumb>

          {loading ? (
            <Row
              className="text-center w-100"
              style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner animation="border" />
            </Row>
          ) : (
            <>
              <Row className="mb-3" id="mb-rw">{renderTracks()}</Row>
              <Row className="mb-3">
                <Col xs={12} className="d-flex justify-content-between align-items-center">
                  {userRole === "Admin" && (
                  <button className="btn btn-primary sv_btn" onClick={handleAddTrack}>
                    + Add New Track
                  </button>
                  )}
                  {/*<button className="btn btn-secondary sv_btn" onClick={handleNext}>
                    Configurations
                  </button>*/}
                </Col>
              </Row>
            </>
          )}
        </Container>
        <ThinFooter />
      </ContentWrapper>
      <ConfirmationDialog
        show={showDialog}
        onClose={handleCloseDialog}
        title={dialogConfig.title}
        bodyText={dialogConfig.bodyText}
        confirmText={dialogConfig.confirmText}
        cancelText={dialogConfig.cancelText}
        onConfirm={dialogConfig.onConfirm}
      />
      <Toaster />
    </>
  );
};

export default RaceTrackMap;
